export default "__VITE_ASSET__D7Pec59D__"